var render = function render(){var _vm=this,_c=_vm._self._c;return _c('money',_vm._b({staticClass:"form-control",attrs:{"value":_vm.value,"maxlength":"14"},on:{"input":_vm.handleChange}},'money',_vm.monetary,false))
}
var staticRenderFns = []

export { render, staticRenderFns }